// ----------------- UPDATE PREVIOUS LOCATION -----------------
export const UPDATE_PREVIOUS_LOCATION = 'UPDATE_PREVIOUS_LOCATION';

// ----------------- SAVE_LATEST_NO_AUTH_PATH -----------------
export const SAVE_LATEST_NO_AUTH_PATH = 'SAVE_LATEST_NO_AUTH_PATH';
